'use client';

import React, { useRef, useEffect } from 'react';
import { REGEX_PATTERNS } from '@/shared/config/common/constants/patterns';
import { featureBookingModalConfig } from '@/shared/config/tests/e2e/features/booking';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/shared/ui/input-otp';
interface Props {
  otp: string;
  statusOTP: 'success' | 'default' | 'error';
  statusOTPMessage: string;
  visible: boolean;
  changeOTP: (newValue: string) => void;
}
export const BookingOTPForm: React.FC<Props> = props => {
  const {
    otp,
    statusOTP,
    statusOTPMessage,
    visible,
    changeOTP
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (visible && inputRef.current) {
      inputRef.current.focus();
    }
  }, [visible]);
  return <div className="mt-4 flex flex-col items-center justify-center" data-sentry-component="BookingOTPForm" data-sentry-source-file="BookingOTPForm.tsx">
      <InputOTP pattern={REGEX_PATTERNS.IS_DIGIT as unknown as string} maxLength={4} value={otp} ref={inputRef} onChange={changeOTP} data-testid={featureBookingModalConfig.ids.bookingOTPInput} data-sentry-element="InputOTP" data-sentry-source-file="BookingOTPForm.tsx">
        <InputOTPGroup data-sentry-element="InputOTPGroup" data-sentry-source-file="BookingOTPForm.tsx">
          <InputOTPSlot variant={statusOTP} index={0} data-sentry-element="InputOTPSlot" data-sentry-source-file="BookingOTPForm.tsx" />
          <InputOTPSlot variant={statusOTP} index={1} data-sentry-element="InputOTPSlot" data-sentry-source-file="BookingOTPForm.tsx" />
          <InputOTPSlot variant={statusOTP} index={2} data-sentry-element="InputOTPSlot" data-sentry-source-file="BookingOTPForm.tsx" />
          <InputOTPSlot variant={statusOTP} index={3} data-sentry-element="InputOTPSlot" data-sentry-source-file="BookingOTPForm.tsx" />
        </InputOTPGroup>
      </InputOTP>

      {statusOTP === 'success' && <p className="mt-2 text-center text-base text-statusSuccess">{statusOTPMessage}</p>}
    </div>;
};